import axios from "axios";
import { Constants } from "../utils/Constants";

export function login(email, password) {
  return axios.post(`${Constants.baseUrl}/auth`, { email, password });
}

export function verifyMfaLogin(email, mfaToken, code) {
  return axios.post(`${Constants.baseUrl}/mfa/verify-login`, {
    email,
    mfa_token: mfaToken,
    code,
  });
}

export function logout() {
  return axios.get(`${Constants.baseUrl}/logout`);
}

export function forgot(form) {
  return axios.post(`${Constants.baseUrl}/forgot-password`, form);
}

export function reset(form) {
  return axios.post(`${Constants.baseUrl}/reset-password`, form);
}

export function getMfaStatus() {
  return axios.get(`${Constants.baseUrl}/mfa/status`);
}

export function setupMfa() {
  return axios.post(`${Constants.baseUrl}/mfa/setup`);
}

export function enableMfa(code) {
  return axios.patch(`${Constants.baseUrl}/mfa/enable`, { code });
}

export function disableMfa(password, code) {
  return axios.delete(`${Constants.baseUrl}/mfa`, { data: { password, code } });
}
